// Each map has its own request sequence: updating the comparison map must not
// cancel the main map, and an old satellite response must not replace a survey.
export default function createMapLayerRequestTracker() {
  const requests: Record<string, object> = {};
  return (mapName: string): (() => boolean) => {
    const request = {};
    requests[mapName] = request;
    return () => requests[mapName] === request;
  };
}
